"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Products = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../../../constants");
var _personalProductListEditContext = require("../../../../contexts/personalProductListEditContext");
var _utils = require("../../../../utils");
var _Product = require("../Product/Product");
var _ProductEmpty = require("../ProductEmpty");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Products = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { products, setProducts } = (0, _personalProductListEditContext.usePersonalProductListEditContext)();
    const productsWithEmpty = (0, _react.useMemo)(()=>[
            ...products,
            ...Array.from({
                length: _constants.NUM_OF_PRODUCTS - products.length
            }, ()=>(0, _utils.generateEmptyProduct)())
        ], [
        products
    ]);
    const onRemove = (0, _react.useCallback)((product)=>{
        setProducts(products.filter((item)=>{
            if (item.type === 'product') {
                return item.code !== product.code;
            }
            return true;
        }));
    }, [
        products,
        setProducts
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ProductsContainer, {
        "data-testid": getTestId(_constants2.PRODUCTS),
        children: productsWithEmpty.map((product, index)=>{
            if (product.type === 'product') {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Product.Product, {
                    product: product,
                    onRemove: onRemove
                }, product.code);
            }
            // eslint-disable-next-line react/no-array-index-key -- we dont have unique key for empty products
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProductEmpty.ProductEmpty, {}, index);
        })
    });
};
exports.Products = Products;
